import { Image } from "@/components/ui/image";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import { Divider } from "@/components/ui/divider";
import { ScrollView } from "react-native-gesture-handler";
import React, { useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { backendRequest } from "@/stores/thunks";
import i18n from "i18n-js";
import Footer from "@/components/basic/Footer";
import Header from "@/components/basic/Header";
import ImageSynced from '@/components/media/ImageSynced';
import PressableElement from "@/components/basic/PressableElement";
import OnlineButton from '@/components/basic/OnlineButton';
import Moment from "moment";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { switchScreen } from '@/hooks/navigate';
import avatar1 from "@/assets/images/avatar_mit_background.png"
import {AppState} from "react-native";
import {useIsFocused} from "@react-navigation/native";

export default function ContactManagement({ navigation }) {

    const user = useSelector((state) => state.user)
    const server = useSelector((state) => state.server)
    const contacts = useSelector((state) => state.contacts)
    const dispatch = useDispatch()
    const insets = useSafeAreaInsets()
    const [appState, setAppState] = useState(AppState.currentState);
    const [trigger, setTrigger] = useState(0);
    const isFocused = useIsFocused();

    useEffect(() => {
        dispatch(backendRequest('GET_CONTACTS_INLINE', '/contact/user', null, 'GET', false))
    }, [trigger, isFocused])

    // checked ob die Page aus dem Hintergrund geöffnet wird
    useEffect(() => {
        const subscription = AppState.addEventListener("change", nextAppState => {
            if (appState.match(/background|inactive/) && nextAppState === "active") {
                console.log("App ist zurück aus dem Hintergrund!");
                setTrigger(prev => prev + 1);
            }
            setAppState(nextAppState);
        });

        return () => subscription.remove();
    }, [appState]);

    const addChannel = () => {
        switchScreen(navigation, 'Channel', {
            channel: {
                id: null,
                name: null,
                description: null,
                channelImage: null,
                contacts: [],
                workflows: [],
                createdAt: null,
                createdBy: {
                    id: user.id
                },
                modifiedAt: null
            }, isEdit: true
        })
    }

    const addContact = () => {
        switchScreen(navigation, 'Alternatives', { title: 'addContact.title', screenA: 'ModalAddContactEmail', textA: 'addContact.searchMail', screenB: 'ScanQRCode', textB: 'addContact.scanCode' })
    }

    const buttonAddChannel = { action: addChannel, info: 'contactManagement.addChannel' }
    const buttonAddContact = { action: addContact, info: 'contactManagement.addContact' }

    return (
        <View className="flex-1 bg-secondary-50">
            <Header navigation={navigation} options={{ title: i18n.t('contactManagement.title') }} />
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: server.online ? 140 + insets.bottom : 90 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3">
                <VStack space='2xl'>
                    <VStack space='xl'>
                        <Text className="text-2xl text-secondary-900">{i18n.t('contactManagement.contactRequest')}</Text>
                        <Text className="px-3 text-xl text-secondary-900">{i18n.t('contactManagement.requestFrom', { num: contacts.requests.filter(request => request.toUser.id == user.id).length || 0 })}</Text>
                        {contacts.requests.filter(request => request.toUser.id == user.id).map((request, index) => <ContactRequestListElement key={'R' + index} request={request} sender={false} />)}
                        <Divider />
                        <Text className="px-3 text-xl text-secondary-900">{i18n.t('contactManagement.requestTo', { num: contacts.requests.filter(request => request.fromUser.id == user.id).length || 0 })}</Text>
                        {contacts.requests.filter(request => request.fromUser.id == user.id).map((request, index) => <ContactRequestListElement key={'R' + index} request={request} sender={true} />)}
                    </VStack>
                    <Divider />
                    <PressableElement px='0' fontSize='text-2xl' mainText={i18n.t('contactManagement.contacts', { num: contacts.active.length })} pressed={() => switchScreen(navigation, 'Contacts', {})} />
                    <Divider />
                    <PressableElement px='0' fontSize='text-2xl' mainText={i18n.t('contactManagement.channels', { num: contacts.channels.length })} pressed={() => switchScreen(navigation, 'Channels', { isEdit: false })} />
                    <Divider />
                </VStack>
            </ScrollView>
            <Footer navigation={navigation} button={server.online ? buttonAddChannel : null} button2={server.online ? buttonAddContact : null} />
        </View>
    );
}

function ContactRequestListElement({ request, sender }) {
    const dispatch = useDispatch()
    const imgLoad = useSelector((state) => state.images.load)

    return (
        <View>
            {sender ? (
                <VStack space='md'>
                    <HStack space='sm'>
                        <Image key={avatar1} source={avatar1} alt={i18n.t('global.missingImage')} size='sm' />
                        <VStack space='sm' className="mt-3">
                            <Text bold className="text-xl text-secondary-900">{request.toUser.mail}</Text>
                            <Text className="text-lg text-secondary-900">{i18n.t('contactManagement.request', { date: Moment(request.createdAt).format('DD.MM.YYYY') })}</Text>
                        </VStack>
                    </HStack>
                    <HStack space='xs' className="justify-between">
                        <OnlineButton onPress={() => {
                            dispatch(backendRequest('DELETE_REQUEST_INLINE', '/contact/request', { userId: request.toUser.id, requestId: request.id }, 'DELETE'))
                                .then(contacts => console.log('DEL', contacts))
                        }}>{i18n.t('contactManagement.cancel')}</OnlineButton>
                    </HStack>
                </VStack>
            ) : (
                <VStack space='md'>
                    <HStack space='sm'>
                        <ImageSynced key={request.fromUser.id + '_' + imgLoad[request.fromUser.id]?.duration} uri={request.fromUser.id} sync={'/user/' + request.fromUser.id + '/userImage'} size='sm' />
                        <VStack space='sm' className="mt-3">
                            <Text bold className="text-xl text-secondary-900">{request.fromUser.mail}</Text>
                            <Text className="text-lg text-secondary-900">{i18n.t('contactManagement.request', { date: Moment(request.createdAt).format('DD.MM.YYYY') })}</Text>
                        </VStack>
                    </HStack>
                    <HStack space='xs' className="justify-between">
                        <OnlineButton size='lg' onPress={() => { dispatch(backendRequest('ACCEPT_REQUEST_INLINE', '/contact', { userId: request.fromUser.id, requestId: request.id }, 'POST')) }}>{i18n.t('contactManagement.accept')}</OnlineButton>
                        <OnlineButton size='lg' variant='outline' onPress={() => { dispatch(backendRequest('DECLINE_REQUEST_INLINE', '/contact/request', { userId: request.fromUser.id, requestId: request.id }, 'PUT')) }}>{i18n.t('contactManagement.deny')}</OnlineButton>
                    </HStack>
                </VStack>
            )}
        </View>
    );
}
